import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
// @ts-ignore
// import OSS from 'ali-oss';
// @ts-ignore
import ObsClient from 'esdk-obs-browserjs';
// @ts-ignore
import SparkMD5 from 'spark-md5';
import { UserService } from './user.service';
import { ResType } from '../model/Const';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import axios from 'axios';

enum TRANSCODING_TYPE  {
  AUDIO= 890881,
  VIDEO= 890880,
}


@Injectable({
  providedIn: 'root'
})
export class HWResourceService extends BaseService {

  static bucketPath = 'ireadabc';
  static cdnHost = 'hw-cdn.ireadabc.com';

  static resolveMediaUrl(url = '', bucket = '') {
    if (!url || url.startsWith('blob:') || url.startsWith('data:')) {
      return url;
    }
    const pageProtocol = typeof window !== 'undefined'
      ? new URL(window.location.href).protocol
      : 'https:';
    const host = HWResourceService.cdnHost;
    let result: string;
    if (/^https?:\/\//.test(url)) {
      result = url;
    } else {
      const path = url.startsWith('/') ? url.substring(1) : url;
      result = `${pageProtocol}//${host}/${bucket ? bucket + '/' : ''}${path}`;
    }
    if (pageProtocol === 'https:' && result.startsWith('http://')) {
      result = `https://${result.slice('http://'.length)}`;
    }
    return result;
  }
  bucket = 'ireadabc';
  audioTransBucket = 'ireadabc-transcoding-audio';
  videoTransBucket = ' ireadabc-transcoding-video';
  ak = '0MIC80VIWUFAV92NU1FA';
  sk = '17xeJueRtxwXRBmd3qq3X6SUOz1Bip9BGEytWR4L';
  cdn = 'hw-cdn.ireadabc.com';
  source = 'ireadabc.obs.cn-north-4.myhuaweicloud.com';
  server = 'obs.cn-north-4.myhuaweicloud.com';
  schema = 'https';
  project_id = 'ed8e31533ccb4de4827e7c913857bde0';


  constructor(private userService: UserService,
              protected override http: HttpClient,
              protected override router: Router,
              private zone: NgZone) {
    super(http, router);
    // this.domain = `${this.schema}://${this.bucket}.${this.region}.aliyuncs.com`;

  }


  checkFileHash (file?: File & {url: string}): Promise<string>|null {
    if (!file) {
      return null;
    }
    const self = this;
    const md5Lib = SparkMD5;
    return new Promise((resolve, reject) => {
      // eval(self.workerThreadSource);

      const blobSlice = File.prototype.slice,
        chunkSize = 2097152, // Read in chunks of 2MB
        chunks = Math.ceil(file.size / chunkSize),
        spark = new SparkMD5.ArrayBuffer(),
        fileReader = new FileReader();

      let currentChunk = 0;

      fileReader.onload = function (evt: any) {
        // console.log('read chunk nr', currentChunk + 1, 'of', chunks);
        spark.append(evt.target.result); // Append array buffer
        // spark.append(this.result); // Append array buffer
        currentChunk++;

        if (currentChunk < chunks) {
          loadNext();
        } else {
          // Compute hash
          const file_hash = spark.end();
          resolve(file_hash) ;
        }
      };

      fileReader.onerror = function () {
        console.warn('oops, something went wrong.');
        reject();
      };

      function loadNext() {
        try {
          if (!file) {
            return;
          }
          const start = currentChunk * chunkSize,
            end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;

          fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
        } catch (e) {
          reject(e);
        }

      }
      loadNext();
    });

  }

  checkOSSObject(hash: string, bucket?: string, file?: File) {

    const url =  `${this.schema}://${this.source}`  + (hash.startsWith('/') ? hash : `/${hash}`);
      // `https://${this.domain}` + hash;
    console.log('check', url);
    return new Promise((resolve, reject) => {
      fetch(url, {method: 'HEAD'}).then((info: any) => {
        console.log('check ok', info);
        const {status} = info;
        if (status === 200 || status === 304) {
          if (!info.url) {
            info.url = url;
          }
          resolve({info, client: null});
        } else {
          this.getObsClient().then(client => {
            resolve({info: null, client});
          });
        }
      }).catch((err: any) => {
        return this.getObsClient().then(client => {
          resolve({info: null, client});
        });
      });
    });

  }

  async getObsClient() {

    const client =  new ObsClient({
      access_key_id: this.ak,
      secret_access_key: this.sk,
      server : this.server,
      timeout : 60 * 30,
      // signature : 'obs'
    });
    return client;
  }

  asyncDoUpload(options: {file: File & {url: string}|null, /* type: ResType,*/
    osspath: string,
    hash?: string,
    bucket?: string,
    progress_cb?: (s: any, file?: File) => any,
    success_cb?: (name: any, hash: any, url: string, file?: File, inOSS?: boolean) => any,
    error_cb?: (s: any, file?: File) => any,
    check_cb?: (s: any) => any }) {
    return new Promise<void>((resolve, reject) => {
      this.doUpload({
        ...options,
        // @ts-ignore
        progress_cb: (percent: number) => {
          if (options.progress_cb) {
            // @ts-ignore
            options.file.percent = percent;
            // @ts-ignore
            options.progress_cb({percent}, options.file);
          }
        },
        success_cb: async (name: any, hash: any, url: string, file?: File, inOSS?: boolean) => {
          if (options.success_cb) {
            // @ts-ignore
            await options.success_cb({name, hash, url, file});
            resolve();
          }
        },
        error_cb: (s: any, file?: File) => {
          if (options.error_cb) {
            // options.error_cb(s, file);
          }
          s.file = file;
          // @ts-ignore
          file.error = s;
          reject(s);
        },
        // check_cb
      });
    });
  }
  blobToUint8Array = async  (blob: Blob) => {
    const buffer = await blob.arrayBuffer();
    return new Uint8Array(buffer);
  }
  isMP3 = async (file: File) => {
    const blob = file.slice(0, 4);
    const header = await this.blobToUint8Array(blob);
    // Check for ID3v2 tag (starts with "ID3")
    if ( header[0] === 0x49 &&
      header[1] === 0x44 &&
      header[2] === 0x33) {
      return true;
    }

    // Check for MPEG frame header (starts with 0xFF and 0xEx-0xFx)
    // tslint:disable-next-line:no-bitwise
    if (header[0] === 0xFF && (header[1] >>> 4) === 0xE) {
      return true;
    }
    const view = new DataView(await blob.arrayBuffer());

    // 检查ID3v2标签 (ID3)
    if (view.getUint8(0) === 0x49 && // I
      view.getUint8(1) === 0x44 && // D
      view.getUint8(2) === 0x33) { // 3
      return true;
    }

    // 检查MPEG音频帧头 (FF FB/FF F3/FF F2)
    if (view.getUint8(0) === 0xFF &&
      // tslint:disable-next-line:no-bitwise
      (view.getUint8(1) & 0xF0) === 0xF0) {
      return true;
    }


    return false;


    // const header = new Uint8Array(file.slice(0, 2));
    // return header[0] === 0x49 && header[1] === 0x44; // "ID"标识
  }
  doUpload = async (options: {file: File | {url: string}|null, /* type: ResType,*/
              osspath: string,
              hash?: string,
              bucket?: string,
              progress_cb?: (s: any, file?: File) => any,
              success_cb?: (name: any, hash: any, url: string, file?: File, inOSS?: boolean) => any,
              error_cb?: (s: any, file?: File) => any,
              check_cb?: (s: any) => any }) => {

    if ((options?.file as File)?.name?.endsWith('.mp3') || (options?.file as File)?.name?.endsWith('.MP3')) {
      const mp3 = await this.isMP3(options?.file as File);
      if (!mp3) {
        console.error('canot detect mp3 file');
        if (options?.error_cb) {
          options?.error_cb( new Error('mp3文件错误， 请重新选择上传文件'), (options?.file as File));
        }
        return;
      }
    }


    let hasher = null;
    if (options.hash) {
      // @ts-ignore
      hasher = new Promise<string>((resolve, reject) => resolve(options.hash));
    } else {
      // @ts-ignore
      hasher = this.checkFileHash(options.file);
    }
    if (!hasher) {
      console.error('canot detect hasher');
      if (options?.error_cb) {
        // @ts-ignore
        options?.error_cb(new Error( 'canot dected checker'), options?.file);
      }
      return;
    }

    hasher.then((hash: string) => {
      if (options.check_cb) {
        options.check_cb(hash);
      }
      const ext = (options?.file as File)?.name.substr((options?.file as File)?.name.lastIndexOf('.') );
      let target_path = [_.trim(options.osspath, '/'), hash + '_f' + ext].join('/').toLowerCase();
      if (ext?.toLocaleLowerCase() !== '.mp3' && ext?.toLocaleLowerCase() !== '.mp4') {
        target_path = [_.trim(options.osspath, '/'), hash + ext].join('/');
      }
      // const target_path = [_.trim(options.osspath, '/'), hash + '_f' + ext].join('/');
      console.log('target_path', target_path);
      let checker = null;
      if (options.hash) {
        checker = this.getObsClient().then(client => {
          return {info: null, client};
        });
      } else {
        // @ts-ignore
        checker = this.checkOSSObject(target_path, options.bucket, options.file);
      }
      checker.then((res: any) => {
        const {info, client} = res;
        if (!client && !info) {
          // @ts-ignore
          options?.error_cb({message: 'system error'});
          return ;
        }
        if (info) {
          let url = info.url || info.res.requestUrls[0];
          const u = new URL(url);
            u.protocol = `${this.schema}:`;
            u.host = `${this.cdn}`;
            url = u.toString();
          console.log(url);
          if ( url.indexOf('?') > -1 ) {
            url = url.substring(0, url.indexOf('?'));
          }
          // @ts-ignore
          options?.success_cb(options?.file?.name, hash, url, options?.file, true);
        } else if (client) {
          this.uploadFile(client,
            options.file, options.osspath,
            hash,  /*type,*/ options.progress_cb,
            options.success_cb, options.error_cb);
        }
      }).catch((e: any) => {
        // @ts-ignore
        options?.error_cb({message: '上传失败，请重试'});
      });
    });

  }

  async uploadFile (client: any, file: any, path: string,  hash: string,  /*type,*/  progress_cb: any, success_cb: any, error_cb: any) {
    console.log('uploadFile', path,  hash);
    const ext = file.name.substr(file.name.lastIndexOf('.') );
    // let transBucket: string | null = null;
    // if (ext.toLowerCase() === '.mp4') {
    //   transBucket = this.videoTransBucket;
    // }
    // if (ext.toLowerCase() === '.mp3') {
    //   transBucket = this.audioTransBucket;
    // }

    const key     = (_.trim([_.trim(path, '/'), hash + ext].join('/'), '/')).toLowerCase();
    const new_key = (_.trim([_.trim(path, '/'), hash + '_f' + ext].join('/'), '/')).toLowerCase();
    const user_info = this.userService.getUserInfo();
    const meta = {
      fileName: encodeURI(file.name),
      fileMd5: hash
    };
    if (user_info && user_info.id) {
      // @ts-ignore
      meta.userId = user_info.id;
    }
    try {
      const resp: any = await this.putObject(client, {
        Bucket : this.bucket,
        Key : key,
        SourceFile : file,
        ProgressCallback: progress_cb,
        Metadata: meta
      });
      if (resp.CommonMsg.Status  < 300) {

        const copyResult = await this.copyObjectWithClient(client, {
          Bucket: this.bucket,
          Key: new_key,
          CopySource : this.bucket + '/' + key,
        });
        // @ts-ignore
        if (copyResult.CommonMsg.Status  < 300) {
          success_cb(file.name, hash, `${this.schema}://${[this.cdn, new_key ].join('/')}`, file);
        } else {
          error_cb({message: resp.CommonMsg.Message}, file);
        }
      } else {
        success_cb(file.name, hash, `${this.schema}://${[this.cdn, new_key ].join('/')}`, file);
      }
    } catch (e: any) {
      error_cb({message: e.message}, file);
    }
    return;



    client.putObject({
      Bucket : this.bucket,
      Key : key,
      SourceFile : file,
      ProgressCallback: progress_cb,
      Metadata: meta
    }).then((resp: any) => {
      if (resp.CommonMsg.Status  < 300) {
          client.copyObject({
            Bucket: this.bucket,
            Key: key,
            CopySource : this.bucket + '/' + key,
            MetadataDirective : client.enums.CopyMetadata
          }).then((copyResult: any) => {
            if (copyResult.CommonMsg.Status < 300) {
              success_cb(file.name, hash, `${this.schema}://${[this.cdn, key ].join('/')}`, file);
            } else {
              error_cb({message: resp.CommonMsg.Message}, file);
            }
          });

      } else {
        error_cb({message: resp.CommonMsg.Message}, file);
      }






      return;
      let url = resp.res.requestUrls[0];
      const u = new URL(url);
      // if (u.host !== this.domain) {
        u.protocol = `${this.schema}:`;
        u.host = `${this.cdn}`;
        url = u.toString();
      // }
      console.log('asdfasfasd', url);
      if ( url.indexOf('?') > -1 ) {
        url = url.substring(0, url.indexOf('?'));
      }
      success_cb(file.name, hash, url, file);

    }).catch((e: any) => {
      if (error_cb) {
        error_cb(e, file);
      }
    });
  }
  putObject(client: any, {Bucket, Key , SourceFile, ProgressCallback, Metadata }: {
              Bucket: string,
              Key: string,
              SourceFile: File,
              ProgressCallback: (p: number) => void,
              Metadata: any
            }) {
    return new Promise((resolve, reject) => {
      client.putObject({
        Bucket : this.bucket,
        Key ,
        SourceFile ,
        // OBS ProgressCallback(loadedBytes, totalBytes, seconds) —— 转成 0~1 比例给业务层
        ProgressCallback: ProgressCallback
          ? (loaded: number, total: number) => {
              const percent = total > 0 ? loaded / total : 0;
              ProgressCallback(Math.min(1, Math.max(0, percent)));
            }
          : undefined,
        Metadata
      }).then((resp: any) => {
        resolve(resp);
      }).catch((e: any) => {
        reject(e);
      });
    });
  }
  copyObjectWithClient(client: any, {Bucket, Key, CopySource }: {Bucket: string,
    Key: string,
    CopySource: string}) {
    return new Promise((resolve, reject) => {
      client.copyObject({
        Bucket,
        Key,
        CopySource ,
        MetadataDirective : client.enums.CopyMetadata
      }).then((copyResult: any) => {
        resolve(copyResult);
      }).catch((e: any) => {
        reject(e);
      });
    });
  }

  /**
   * 复制 OBS 对象到新 Key（自动获取 client）。
   * @example
   * await hwResource.copyObject({
   *   Key: 'path/new.mp3',
   *   CopySource: 'ireadabc/path/old.mp3',
   * });
   */
  async copyObject({
    Bucket,
    Key,
    CopySource,
  }: {
    Bucket?: string;
    Key: string;
    CopySource: string;
  }) {
    if (!Key || !CopySource) {
      throw new Error('Key and CopySource are required');
    }
    const client = await this.getObsClient();
    const bucket = Bucket || this.bucket;
    const copyResult: any = await this.copyObjectWithClient(client, {
      Bucket: bucket,
      Key,
      CopySource,
    });
    if (!(copyResult?.CommonMsg?.Status < 300)) {
      throw new Error(copyResult?.CommonMsg?.Message || 'Copy object failed');
    }
    return copyResult;
  }

  deleteObject(client: any, {Bucket, Key}: {Bucket: string, Key: string}) {
    return new Promise((resolve, reject) => {
      client.deleteObject({
        Bucket,
        Key,
      }).then((resp: any) => {
        resolve(resp);
      }).catch((e: any) => {
        reject(e);
      });
    });
  }

  /**
   * OBS 普通桶无原生 rename，通过 copy + delete 实现重命名。
   */
  async renameObject(client: any, {
    Bucket,
    OldKey,
    NewKey,
  }: {
    Bucket: string;
    OldKey: string;
    NewKey: string;
  }) {
    if (!OldKey || !NewKey) {
      throw new Error('OldKey and NewKey are required');
    }
    if (OldKey === NewKey) {
      return { skipped: true };
    }

    const copyResult: any = await this.copyObjectWithClient(client, {
      Bucket,
      Key: NewKey,
      CopySource: Bucket + '/' + OldKey,
    });
    if (!(copyResult?.CommonMsg?.Status < 300)) {
      throw new Error(copyResult?.CommonMsg?.Message || 'Copy object failed');
    }

    const deleteResult: any = await this.deleteObject(client, {
      Bucket,
      Key: OldKey,
    });
    if (!(deleteResult?.CommonMsg?.Status < 300)) {
      throw new Error(deleteResult?.CommonMsg?.Message || 'Delete source object failed after copy');
    }

    return { copyResult, deleteResult };
  }

  /**
   * 使用默认 bucket 重命名对象。
   */
  async rename(oldKey: string, newKey: string, bucket?: string) {
    const client = await this.getObsClient();
    return this.renameObject(client, {
      Bucket: bucket || this.bucket,
      OldKey: oldKey,
      NewKey: newKey,
    });
  }


  add(data: any) {
    return super.post(`/resource`, data).then((resp) => {
      return resp;
    });
  }
  getByHash(type: ResType, hash: string) {
    // let t = '0';
    // if (type === ResType.PIC) {
    //   t = 'image';
    // } else if (type === ResType.AUDIO) {
    //   t = 'audio';
    // }
    return super.get(`/resource/info/${type}/${hash}`);
  }
  updateAudio(id: string, data: string) {
    return super.post(`/resource/audio/${id}`, data).then((resp) => {
      return resp;
    });
  }
  updateImage(id: string, data: string) {
    return super.post(`/resource/image/${id}`, data).then((resp) => {
      return resp;
    });
  }
  updateVideo(id: string, data: string) {
    return super.post(`/resource/video/${id}`, data).then((resp) => {
      return resp;
    });
  }
}
